import React, { useState } from "react";
import { Modal, Button as RBButton } from 'react-bootstrap';
import Hack4tts_dataset from "./Hack4tts_dataset"; // update path accordingly
import application_contants from '../../../contants/application_contants'; 
function Hack4TTSModalAboutDataset() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Click Here for more info
      </Button> */}

    <div className="registers-container">
      <a onClick={handleShow} className="regist-btn-outline">
        Read More
      </a> 
    </div>

      <Modal show={show} onHide={handleClose} size="lg" className="custom-only-close">
        {/* NOTE: no `closeButton` prop here */}
        <Modal.Header className="position-relative">
          <Modal.Title>Voice Tech for All: About the Datasets</Modal.Title>
        
          {/* Your custom close button */}
          <button
            type="button"
            className="modal-close-btn"
            onClick={handleClose}
            aria-label="Close"
          >
            <img src={application_contants.CLOSEIMG} alt="Close" className="modal-close-img" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Hack4tts_dataset />
        </Modal.Body>
        <Modal.Footer>
          <RBButton variant="secondary" onClick={handleClose}>
            Close
          </RBButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Hack4TTSModalAboutDataset;
